"use strict";
exports.__esModule = true;
exports.DEPOSIT_TOOLTIP = void 0;
exports.DEPOSIT_TOOLTIP = {
    HEADER: 'What is this deposit?',
    PARAGRAPH_1: function (amount) {
        return "You unlock your secured credit line of ".concat(amount, " with this deposit. We use this credit line to pay your rent in full and on time.");
    },
    PARAGRAPH_2: "After we pay your rent, you'll owe the whole credit line amount back. To simplify your experience, we automatically collect your deposit to pay off the rest of the credit line.",
    PARAGRAPH_3: function (secondInstallmentAmount, processingFee) {
        return "This way, you'll only need to worry about the remaining ".concat(secondInstallmentAmount, " and ").concat(processingFee, " monthly rate.");
    },
    CTA_TEXT: 'Close'
};
